import { render, staticRenderFns } from "./FunctionaryPermissionsModal.vue?vue&type=template&id=6360cd38&"
import script from "./FunctionaryPermissionsModal.vue?vue&type=script&lang=js&"
export * from "./FunctionaryPermissionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports